import { render, staticRenderFns } from "./MessagesAside.vue?vue&type=template&id=7e77093d&scoped=true&"
import script from "./MessagesAside.vue?vue&type=script&lang=js&"
export * from "./MessagesAside.vue?vue&type=script&lang=js&"
import style0 from "./MessagesAside.vue?vue&type=style&index=0&id=7e77093d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e77093d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VImg})
